<template>
    <div>
        <div v-if="hint" v-text="hint" />
        <div class="d-flex">
            <div class="pr-2" style="width:30%"><v-text-field :label="label" v-model="size" type="number" step="0.1" :min="min" :max="max" color="zoezi-edit-color" @wheel.native="$event.target.blur()" @change="clampSize" /></div>
            <div class="pl-2" style="width:70%"><v-select :items="units" v-model="unit" color="zoezi-edit-color" /></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CssSizeSetting',

    props: {
        value: {},
        label: {},
        allowNumber: {
            type: Boolean
        },
        hint: {},
        min: {
            default: undefined
        },
        max: {
            default: undefined
        }
    },

    watch: {
        value: {
            immediate: true,
            handler(value) {
                let units = this.units.map(u => u.value).join('|')
                let re = new RegExp(`^([0-9.]+)(${units})$`);
                let m = value && value.match(re);
                if (m) {
                    this.size = Number(m[1]);
                    this.unit = m[2];
                } else {
                    this.size = null;
                    this.unit = 'px';
                }
            }
        },
        emitValue(value) {
            this.$emit('input', value?.replace(',', '.'));
        }
    },

    computed: {
        emitValue() {
            return this.size ? (this.size + this.unit) : null;
        },
        units() {
            return [
                {value: '', text: 'Times text size'},
                {value: 'px', text: 'Pixels (px)'},
                {value: '%', text: 'Percent (%)'},
                {value: 'rem', text: 'Font size relative (rem)'},
                {value: 'vw', text: 'Viewport width relative (vw)'},
                {value: 'vh', text: 'Viewport height relative (vh)'}
            ].filter(x => this.allowNumber || x.value !== '').map(x => ({...x, text: this.$translate(x.text)}));
        }
    },

    methods: {
        clampSize() {
            if (this.size == null) return;
            if (this.min != null && this.size < this.min) this.size = this.min;
            if (this.max != null && this.size > this.max) this.size = this.max;
        }
    },

    data: () => ({
        size: null,
        unit: 'px'
    })
}
</script>
